module.exports = __webpack_public_path__ + "media/images/anyspaces-dd10d604bf83a8320d953e3a639a6d80.png";